module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":"報告書を出力中です...","cancel":"キャンセル"},"en":{"label":"Generating a report now...","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
